import { createFileRoute, redirect } from "@tanstack/react-router";
import { canAccessAdmin } from "@/lib/admin";
import { authClient } from "@/lib/auth-client";
import { AdminUsersPage } from "./-AdminUsersPage";

export const Route = createFileRoute("/_settings/admin")({
  // Role-gated (#206): a deep link from a non-admin goes home rather than
  // rendering a page whose API calls would all be refused.
  beforeLoad: async () => {
    const { data } = await authClient.getSession();
    if (!canAccessAdmin(data?.user.role)) throw redirect({ to: "/" });
  },
  component: AdminUsersPage,
  staticData: { title: "Admin" },
});
